import React, { createContext, useState, useEffect } from "react";
import { axiosForm } from "../../axiosInstances";

function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
}

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("accessToken") || null);
  const [refresh, setRefresh] = useState(() => localStorage.getItem("refreshToken") || null);
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Define fetchUserInfo before using it
  const fetchUserInfo = async (user_id) => {
    try {
      const response = await axiosForm.get(`/authentication/api/users/me/`);
      setUser(response.data);
    } catch {
      setUser(null);
    }
  };

  useEffect(() => {
    if (token) {
      setIsAuthenticated(true);
      const payload = parseJwt(token);
      if (payload?.user_id) {
        fetchUserInfo(payload.user_id).finally(() => setLoading(false));
      } else {
        setLoading(false);
      }
    } else {
      setIsAuthenticated(false);
      setUser(null);
      setLoading(false);
    }
  }, [token]);

  const login = (access, refreshToken) => {
    localStorage.setItem("accessToken", access);
    localStorage.setItem("refreshToken", refreshToken);
    setToken(access);
    setRefresh(refreshToken);
    setIsAuthenticated(true);

    const payload = parseJwt(access);
    if (payload?.user_id) {
      fetchUserInfo(payload.user_id);
    }
  };

  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    setToken(null);
    setRefresh(null);
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, refresh, isAuthenticated, login, logout, user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
